/**
 * The homepage's three latest Journal entries, from the same source as /journal.
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadPublishedJournal } from "../../core/content";
import { useLocales } from "../../core/i18n";
import { SectionTitle } from "../../ui/kit";
import { SweepWord } from "../../ui/motion";
import { CONTAINER, SECTION_PAD, TITLE_TO_CONTENT } from "../../ui/shell";
import { JournalList } from "../journal";

/** Renders nothing until an entry is published (or when loading fails). */
const HomeJournal = () => {
	const { t } = useLocales();
	const [entries, setEntries] = useState([]);
	useEffect(() => {
		// Whole entries: the card needs the cover, summary, caption and reading
		// time, not just the title line.
		loadPublishedJournal()
			.then((all) => setEntries(all.slice(0, 3)))
			.catch(() => {});
	}, []);

	if (entries.length === 0) return null;
	return (
		<section className={`bg-pp-bg ${SECTION_PAD}`}>
			<div className={CONTAINER}>
				<SectionTitle>
					<SweepWord dark={false}>
						{t("homepage.journalHomepageTitleHighlight")}
					</SweepWord>
					{t("homepage.journalHomepageTitle")}
					<SweepWord dark={false}>
						{t("homepage.journalHomepageTitleHighlight2")}
					</SweepWord>
				</SectionTitle>
				<div className={TITLE_TO_CONTENT}>
					<JournalList entries={entries} />
					<div className="mt-10">
						<Link to="/journal" className="pp-link">
							{t("homepage.journalHomepageCta")}
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
};

export default HomeJournal;
